import styled from 'styled-components';

import { Button as _Button, MenuItem as _MenuItem } from '@mui/material';
import { wellzTheme as wellzThemeMui } from '@wellz-theme/mui';

import { ChevronByParameter as _ChevronByParameter } from 'components/ChevronByParameter/ChevronByParameter';

export const MenuItem = styled(_MenuItem)`
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.yoga.colors.text.primary};
`;

export const ChevronByParameter = styled(_ChevronByParameter)`
  margin-right: -${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const Button = styled(_Button)`
  line-height: ${({ theme }) => theme.yoga.spacing.large}px;
  letter-spacing: 0.4px;
  margin-right: ${({ theme }) => theme.yoga.spacing.large}px;
  align-items: center;

  ${wellzThemeMui.breakpoints.down('md')} {
    width: 100%;
    margin-right: ${wellzThemeMui.spacing(2.5)};
    margin-left: ${wellzThemeMui.spacing(2.5)};
  }
`;
